
import React from "react";
import { damageAnalysisData } from "@/data/damageAnalysisData";

// Import refactored components
import DamageAnalysisHeader from "./damage-analysis/DamageAnalysisHeader";
import DamageTotalOverview from "./damage-analysis/DamageTotalOverview";
import DamageReasons from "./damage-analysis/DamageReasons";
import SupplierAnalysis from "./damage-analysis/SupplierAnalysis";
import BrandAnalysis from "./damage-analysis/BrandAnalysis";
import ThematicClustering from "./damage-analysis/ThematicClustering";
import BrandComparison from "./damage-analysis/BrandComparison";
import TopDamageProducts from "./damage-analysis/TopDamageProducts";

// Top 10 products with damage cases data
const topDamageProductsData = [
  { product: "S2U Nova Satin", count: 20, percentage: 4.22 },
  { product: "Capatex Mat S1+", count: 20, percentage: 4.22 },
  { product: "Schimmelreiniger", count: 17, percentage: 3.59 },
  { product: "S2U Allure Gloss", count: 15, percentage: 3.16 },
  { product: "Sigmatex Superlatex Matt", count: 12, percentage: 2.53 },
  { product: "Capalac Uniprimer", count: 12, percentage: 2.53 },
  { product: "Capatex Fix", count: 11, percentage: 2.32 },
  { product: "Isotop Mat", count: 11, percentage: 2.32 },
  { product: "Capatex Mat SF", count: 10, percentage: 2.11 },
  { product: "S2U Nova Gloss", count: 10, percentage: 2.11 }
];

const DamageAnalysis: React.FC = () => {
  return (
    <div className="space-y-8">
      <DamageAnalysisHeader />
      
      {/* 1. Total Overview */}
      <DamageTotalOverview
        totalDamageOrders={damageAnalysisData.totalOverview.totalDamageOrders}
        uniqueDamagedProducts={damageAnalysisData.totalOverview.uniqueDamagedProducts}
      />

      {/* 2. Top 5 Reasons for Damage */}
      <DamageReasons damageReasons={damageAnalysisData.damageReasons} />

      {/* 3. Supplier Analysis */}
      <SupplierAnalysis supplierAnalysis={damageAnalysisData.supplierAnalysis} />

      {/* 4. Brand Analysis */}
      <BrandAnalysis brandAnalysis={damageAnalysisData.brandAnalysis} />

      {/* 5. Thematic Clustering */}
      <ThematicClustering thematicClustering={damageAnalysisData.thematicClustering} />

      {/* 6. Sigma vs Caparol Comparison */}
      <BrandComparison sigmaVsCaparol={damageAnalysisData.sigmaVsCaparol} />

      {/* 7. Top 10 Products with Most Damage Cases */}
      <TopDamageProducts products={topDamageProductsData} />
    </div>
  );
};

export default DamageAnalysis;
